import { createFileRoute } from '@tanstack/react-router'
import { CertificatePage } from '../components/pages'
import { CatalogProvider } from '../content/catalog-context'
import { loadPageData } from '../content/page-data-fn'

export const Route = createFileRoute('/fr/certificats/$certificateId')({
  loader: ({ params }) =>
    loadPageData({ data: { kind: 'certificate', locale: 'fr', params } }),
  head: ({ loaderData }) => loaderData?.head ?? {},
  component: RouteComponent,
})

function RouteComponent() {
  const { certificateId } = Route.useParams()
  return (
    <CatalogProvider snapshot={Route.useLoaderData().snapshot}>
      <CertificatePage certificateId={certificateId} />
    </CatalogProvider>
  )
}
